export default __webpack_public_path__ + "static/form-required-field-dont-880a1f1eabf5b001f84b6431cea1aa8d.png";